const Notification = () => import(/* webpackChunkName: "notification" */ '../views/Notification.vue')

const NotificationRoute = [
	{
		path: '/notification',
		name: 'notification',
		component: Notification,
		meta: {
			requiresAuth: true,
			hiddeMenu: true,
			navBar: true,
			navBarBack: true,
			title: 'Notifikasi',
			backLink: 'dashboard',
		},
	},
]

export default NotificationRoute
